module.exports = __webpack_public_path__ + "img/arrow-circle-broken-down-right.99b9dccb.svg";